import { Component, OnInit } from '@angular/core';
import { NotificationService } from 'src/app/services/notification.service';
import { MatSnackBar } from '@angular/material';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss']
})
export class NotificationComponent implements OnInit {

  constructor(
    private _notification: NotificationService,
    private _notify: MatSnackBar
  ) {
    this._notification.notification.subscribe(
      (res:any)=>{
        this.notify(res[0], res[1]);
      }
    );
  }

  public notify(message:string, action:string) {
    this._notify.open(message, action, {
      duration: 4000,
      verticalPosition: 'top'
    });
  }

  ngOnInit() {

  }

}
